import React from 'react';

import {
  FormControlLabel,
  formControlLabelClasses,
  styled,
} from '@mui/material';

import { Market } from '@mewa/types';

import { ConversionTranslations } from './translations-query';

export type FormProps = {
  activeStep: number;
  translations: ConversionTranslations;
  market: Market;
};

export const ConversionStepWrapper: React.FC<
  React.HTMLProps<HTMLDivElement> & {
    isActive: boolean;
  }
> = ({ isActive, children, ...rest }) => (
  <div style={{ display: isActive ? 'block' : 'none' }} {...rest}>
    {children}
  </div>
);

export const Header1 = styled('h1')(({ theme }) => ({
  ...theme.typography.h2,
  fontWeight: theme.typography.fontWeightMedium,
  marginBottom: 'var(--spacer-l)',
  marginTop: 'var(--spacer-xxxl)',

  [theme.breakpoints.down('md')]: {
    marginTop: '80px',
  },

  [theme.breakpoints.down('sm')]: {
    marginTop: '60px',
    marginBottom: '40px',
  },
}));

export const CheckboxWrapper = styled(FormControlLabel)({
  cursor: 'default',

  '&:hover': {
    color: 'var(--color-dark-coal) !important',
  },

  [`&.${formControlLabelClasses.error}`]: {
    'svg .mewaCheckboxRect': {
      stroke: 'var(--color-light-red)',
    },
  },

  p: {
    paddingTop: '6px',
  },
});

export const InputCaption = styled('h3')(({ theme }) => ({
  ...theme.typography.footnote,
  fontWeight: theme.typography.fontWeightMedium,
  marginTop: '30px',
  marginBottom: '12px',
  display: 'flex',
  alignItems: 'center',
  height: '18px',
}));

export const InputLabel = styled('label')(({ theme }) => ({
  ...theme.typography.footnote,
  marginBottom: '12px',
  display: 'flex',
  alignItems: 'center',
  height: '18px',
}));

export const getHelperText = (
  showHelperText: boolean,
  helperText: React.ReactNode,
): React.ReactNode => (showHelperText ? helperText : <span>&nbsp;</span>);

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'column',
  columnGap: '30px',
  rowGap: '20px',
  margin: 'var(--spacer-xl) 0 0',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const BackButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  flexBasis: '100%',

  [theme.breakpoints.up('sm')]: {
    flexBasis: 'auto',
  },
}));

export const CaptchaError = styled('p')(({ theme }) => ({
  color: 'var(--color-light-red)',
  fontSize: '14px',
  lineHeight: '14px',
}));
